import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatePaperMachineApi } from "../../services/machine/update.paper.machine.api";

export const useUpdatePaperMachineApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoUpdate: any) => updatePaperMachineApi(infoUpdate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-machine-of-store", "all-machine"],
      });
    },
  });
};
